import { Type } from 'class-transformer';
import {
  IsArray,
  IsBoolean,
  IsDateString,
  IsIn,
  IsInt,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
  ValidateNested,
} from 'class-validator';

import {
  CommunityInfo,
  ContentItem,
  EntityReactions,
  FeedPostUserActions,
  SocialUser,
} from '@app/gen/dashboard';

export class FeedPostDataType {
  @IsIn(['post'])
  @IsString()
  @IsNotEmpty()
  type: 'post';

  @IsUUID()
  @IsNotEmpty()
  id: string;

  @ValidateNested()
  @Type(() => CommunityInfo)
  @IsNotEmpty()
  community: CommunityInfo;

  @IsString()
  @IsNotEmpty()
  title: string;

  @IsUUID()
  @IsOptional()
  coverAttachmentId?: string;

  @IsIn(['summary', 'extended'])
  @IsString()
  @IsNotEmpty()
  contentType: 'summary' | 'extended';

  @IsString()
  @IsOptional()
  summary?: string;

  @ValidateNested()
  @Type(() => ContentItem)
  @IsOptional()
  content?: ContentItem;

  @IsBoolean()
  @IsNotEmpty()
  commentsEnabled: boolean;

  @IsBoolean()
  @IsNotEmpty()
  reactionsEnabled: boolean;

  @IsString({ each: true })
  @IsArray()
  @IsNotEmpty()
  tags: string[];

  @ValidateNested()
  @Type(() => SocialUser)
  @IsOptional()
  author?: SocialUser;

  @IsDateString()
  @IsNotEmpty()
  createdAt: string;

  @IsDateString()
  @IsOptional()
  publishedAt?: string;

  @IsIn(['owner', 'administrator'])
  @IsString()
  @IsOptional()
  editedBy?: 'owner' | 'administrator';

  @ValidateNested()
  @Type(() => EntityReactions)
  @IsOptional()
  reactions?: EntityReactions;

  @IsInt()
  @IsOptional()
  commentsNum?: number;

  @IsInt()
  @IsOptional()
  viewsNum?: number;

  @IsBoolean()
  @IsOptional()
  isPinnedInFeed?: boolean;

  @ValidateNested()
  @Type(() => FeedPostUserActions)
  @IsOptional()
  actions?: FeedPostUserActions;

  @IsBoolean()
  @IsNotEmpty()
  inFavorites: boolean;
}
